import { api } from ".";

export const fetchPlaylists = async (page = 0, size = 10): Promise<ApiResponse<Playlists>> => {
  const res = await api.get<ApiResponse<Playlists>>(`/playlist?pageSize=${size}&page=${page}`);
  return res.data;
};

export const searchPlaylists = async (
  query = "",
  page = 0,
  size = 10
): Promise<ApiResponse<Playlists>> => {
  const res = await api.get<ApiResponse<Playlists>>(
    `/playlist/search?searchKey=${query}&pageSize=${size}&page=${page}`
  );
  return res.data;
};
